import React from "react";
import { mdiCalendarMonthOutline, mdiFlagOutline } from "@mdi/js";
import HowItWorksModal from "app/components/common/HowItWorksModal";

const ROWS = [
  {
    icon: mdiCalendarMonthOutline,
    title: "Upcoming Jobs",
    body: "Jobs scheduled from today are shown soonest first.",
  },
  {
    icon: mdiFlagOutline,
    title: "Needs Attention Jobs",
    body: "Jobs with an unsigned contract, an unpaid payment, or an email that needs your attention are shown here.",
  },
];

const JobsHowItWorksModal = ({ show, onHide }) => (
  <HowItWorksModal
    show={show}
    onHide={onHide}
    title="How the Jobs page works"
    rows={ROWS}
    className="jobs-how-it-works-modal"
  />
);

export default JobsHowItWorksModal;
